const MOS_PRODUCT_ICONS_PATH = '/images/mos-products';

const MAPAL_OS_BRAND_COLOR = '#301e4a';

/**
 * MOS product code -> icon and brand color, mirrored from @msw/ng-product-switcher 0.10.1
 * (its codes mapping and data-brand background colors) since the MOS API only returns
 * the product code. Icons were copied from @msw/ui-icons into public/images/mos-products.
 */
const MOS_PRODUCT_VISUALS = {
  mapal_os: { icon: 'mapal-os', brandColor: MAPAL_OS_BRAND_COLOR },
  config: { icon: 'configuration', brandColor: MAPAL_OS_BRAND_COLOR },
  admin: { icon: 'administration', brandColor: MAPAL_OS_BRAND_COLOR },
  analytics: { icon: 'analytics', brandColor: '#0073a4' },
  cashrec: { icon: 'cashrec', brandColor: '#507920' },
  compliance: { icon: 'compliance', brandColor: '#6746ca' },
  docs: { icon: 'docs', brandColor: '#b74709' },
  easilys: { icon: 'easilys', brandColor: '#0f4e83' },
  flow: { icon: 'flow', brandColor: '#c7305e' },
  mapal_one: { icon: 'one', brandColor: MAPAL_OS_BRAND_COLOR },
  reputation: { icon: 'reputation', brandColor: '#4065d5' },
  workforce: { icon: 'workforce', brandColor: '#9c1d88' },
  engagement: { icon: 'engagement', brandColor: '#5d0b7a' },
  gir_facilities: { icon: 'facilities', brandColor: '#0f767e' },
  gir_ops: { icon: 'gir-config', brandColor: MAPAL_OS_BRAND_COLOR },
  inpulse: { icon: 'inpulse', brandColor: '#20795b' },
  support: { icon: 'support', brandColor: '#1d122c' },
};

const FALLBACK_PRODUCT_VISUAL = MOS_PRODUCT_VISUALS.mapal_os;

export const getMosProductVisual = (productCode) => {
  const { icon, brandColor } = MOS_PRODUCT_VISUALS[productCode] ?? FALLBACK_PRODUCT_VISUAL;

  return { iconUrl: `${MOS_PRODUCT_ICONS_PATH}/${icon}.svg`, brandColor };
};
